export { LandingFeatureStoreHub } from './lib/landing-feature-store-hub'

export { getStaticProps } from './lib/get-static-props'
export type { StoreHubProps } from './lib/get-static-props'
